/**
 * Textos (ca) de planta — OBR-148: proposta de lot FEFO i escaneig de l'etiqueta: namespace `planta.fefo`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const fefoCa = {
  'planta.fefo': {
    // ── Lot proposat (pesatge d'OT i preparació de comandes) ─────────────────────────────────
    suggestedChip: 'Suggerit (FEFO)',
    scannedChip: 'Escanejat',
    splitHint:
      'La quantitat es reparteix entre diversos lots, per ordre de caducitat. Ho pots canviar.',
    // Un lot del qual ja s'ha pesat quantitat a altres OT obertes d'aquest aparell: encara no baixa de les existències
    // fins que es tanquin, però aquí ja no es pot oferir dues vegades.
    heldByOpenOrders: 'Ja pesat en altres OT obertes: {{quantity}}',
    // Avís NO bloquejant: la quantitat teclejada passa del que l'aparell sap que hi ha al lot.
    overdraw:
      'Al lot {{lot}} només n’hi ha {{available}}: en sobren {{over}}. Pots repartir-ho amb un altre lot o deixar-ho així.',

    // ── Escaneig de l'etiqueta d'un lot ────────────────────────────────────────────────────
    scanButton: 'Escaneja un lot',
    scanPickingTitle: 'Escaneja l’etiqueta del lot',
    scanPickingHint: 'Apunta la càmera al codi QR del lot que vas a servir',
    scanAccepted: 'Lot {{lot}} escanejat i triat.',
    scanNoStock:
      'El lot {{lot}} no té existències a l’aparell. Es tria igualment perquè l’has escanejat.',
    scanNoStockPicking:
      'El lot {{lot}} no té existències a l’aparell: no s’ha pogut posar. Es proposa la resta per ordre de caducitat.',
    // El lot escanejat és vàlid però no és entre els que aquesta línia ofereix (l'aparell no l'ha baixat encara): no s'ha triat.
    scanNotOffered:
      'El lot {{lot}} no consta entre els lots d’aquesta línia a l’aparell, així que no s’ha triat. Torna-ho a provar quan s’hagi sincronitzat.',
    scanUnknown: 'Aquest codi no és cap lot que l’aparell conegui.',
    scanWrongArticle:
      'El lot {{lot}} és de «{{article}}», no de «{{expected}}». No es pot fer servir aquí.',
    scanWrongArticleUnnamed:
      'El lot {{lot}} és d’un altre article, no de «{{expected}}». No es pot fer servir aquí.',
    // Sense el nom de l'article que es prepara (mai s'ensenya un identificador).
    scanWrongArticleGeneric:
      'El lot {{lot}} és de «{{article}}», no de l’article que prepares. No es pot fer servir aquí.',
    scanWrongArticleGenericUnnamed:
      'El lot {{lot}} és d’un altre article, no del que prepares. No es pot fer servir aquí.',
    cascadeHint: 'El lot triat no en té prou: la resta surt d’altres lots, per ordre de caducitat.',
  },
} as const;
